export const APP_STARTED = 'APP_STARTED';